module.exports = __webpack_public_path__ + "img/Reviews and Ratings.092abb77.svg";